import { Component, HostListener, OnInit } from "@angular/core";
import { filter } from "rxjs";
import { AuthService } from "../services/auth/auth.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
    selector: "app-profile",
    templateUrl: "./profile.component.html",
    styleUrls: ["./profile.component.scss"],
    standalone: false,
})
export class ProfileComponent implements OnInit {
    public isMobileView = false;
    public showListOnMobile = true;

    constructor(
        private authService: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
    ) {}

    ngOnInit(): void {
        this.checkScreenSize();
        this.handleInitialNavigation();
        this.handleNavigationEvents();
    }

    private handleInitialNavigation(): void {
        const isBase = this.isBaseAccountRoute();
        this.updateViewBasedOnRoute(isBase);
    }

    private handleNavigationEvents(): void {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            const isBase = this.isBaseAccountRoute();
            this.updateViewBasedOnRoute(isBase);
        });
    }

    private isBaseAccountRoute(): boolean {
        const currentUrl = this.router.url;
        return currentUrl === "/account" || currentUrl === "/account/";
    }

    private updateViewBasedOnRoute(isBase: boolean): void {
        if (isBase) {
            if (!this.isMobileView) {
                // Redirect to /account/overview on desktop
                this.router.navigate(["overview"], { relativeTo: this.route });
            } else {
                // Stay on /account and show menu on mobile
                this.showListOnMobile = true;
            }
        } else {
            // On any other route, adjust menu visibility based on screen size
            this.showListOnMobile = !this.isMobileView;
        }
    }

    @HostListener("window:resize")
    onResize() {
        this.checkScreenSize();
    }

    public checkScreenSize(): void {
        const previousMobileView = this.isMobileView;
        this.isMobileView = window.innerWidth <= 780;

        // If we switched from mobile to desktop AND we are still on /account, redirect to overview
        const currentUrl = this.router.url;
        const isBase = currentUrl === "/account" || currentUrl === "/account/";

        if (!this.isMobileView && previousMobileView && isBase) {
            this.router.navigate(["overview"], { relativeTo: this.route });
        }

        if (this.isMobileView && !previousMobileView) {
            this.showListOnMobile = false;
        }
    }

    public logOut(): void {
        this.authService.logout();
    }

    public goBackToMenu() {
        this.router.navigate(["/account"]);
    }

    public goBack(): void {
        this.location.back();
    }
}
